import React, { useState, useEffect, Fragment,Component } from 'react';

import { Grid } from '@material-ui/core';
import DatePickerCustom from '../../../../commonModules/interface/DatePickerCustom';
import { firstDayOfYear, yearsList } from '../../../../commonModules/utils/statsFunctions';
import { InputSelectNative } from '../../../../commonModules/interface/form-input-inline';
import { isEmpty } from 'lodash';

export const filterDate = (list, from = firstDayOfYear, to = new Date(), field = "date") => {
    console.log('====================================');
    console.log({list, from, to});
    console.log('====================================');
    if (isEmpty(list)){
        return []
    }

    if(!to){
        to = Date.now()
    }
    new Date(from).setHours(0,0,0,0)
    new Date(to).setHours(23,59,59,0)

    let filteredList = Object.values(list).filter( item => 
        new Date(item[field]) >= from 
        && new Date(item[field]) <= to
    )
    console.log('====================================');
    console.log({filteredList});
    console.log('====================================');
    return filteredList
}
export class YearFilter extends Component {
    state = {  }
    render() {
        return (
            <InputSelectNative
                label="Année"
                name="searchYear"
                onChange={this.props.handleChange}
                value={this.props.searchYear}
                labelWidth={70} 
                id="searchYear"
                noEmptyOpt
                options={yearsList().map( year => (
                    <option value={year} key={year}>
                        {year}
                    </option>
                )) }
            /> 
        );
    }
}

const DateFilter = (props) => {

    useEffect(() => {

    }, [props.start_date,props.end_date]);
  
        return (
            <Fragment>
                <Grid item xs={12} sm={6} >
                    <DatePickerCustom
                        required
                        label="Du"
                        handleChange={(date) => props.handleChangeDate(date, "start_date")}
                        value={props.start_date}
                        id="start_date"
                        maxDate={props.end_date || new Date()}
                    />
                </Grid>
                <Grid item xs={12} sm={6} >
                    <DatePickerCustom
                        required
                        label="Au"
                        handleChange={(date) => props.handleChangeDate(date, "end_date")}
                        value={props.end_date || new Date()}
                        id="end_date"
                        maxDate={new Date()}
                        minDate={props.start_date || new Date()}
                    />
                </Grid>

            </Fragment>
        );
}

export default DateFilter;